export const GET_STAFF_DASHBOARD_DETAILS_REQUEST =
  "GET_STAFF_DASHBOARD_DETAILS_REQUEST";
export const GET_STAFF_DASHBOARD_DETAILS_SUCCESS =
  "GET_STAFF_DASHBOARD_DETAILS_SUCCESS";
export const GET_STAFF_DASHBOARD_DETAILS_FAILURE =
  "GET_STAFF_DASHBOARD_DETAILS_FAILURE";
